import { render, staticRenderFns } from "./RepsostaEscalaLikert.vue?vue&type=template&id=a405b238&scoped=true"
import script from "./RepsostaEscalaLikert.vue?vue&type=script&lang=js"
export * from "./RepsostaEscalaLikert.vue?vue&type=script&lang=js"
import style0 from "./RepsostaEscalaLikert.vue?vue&type=style&index=0&id=a405b238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a405b238",
  null
  
)

export default component.exports